export default function ErrorIndicator() {
  return (
    <div
      className="-ml-10 mr-5 inline-block aspect-square w-4
        animate-pulse rounded-full bg-red-100 p-1"
    >
      <div className="aspect-square w-full rounded-full bg-red-400" />
    </div>
  );
}
